import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { SessionsReportFilterForm } from 'src/app/shared/interfaces';

import { Constants } from '../../common';
import { DataWithPagination } from '../../interface';
import { Mapper } from '../mapper/mapper';
import { SessionsReport } from '../model';
import { BaseAPI } from './base-api';

@Injectable({
  providedIn: 'root',
})
export class SessionsReportApi {
  constructor(private baseAPI: BaseAPI, private mapper: Mapper) {}

  getSessionsReport(filter: SessionsReportFilterForm): Observable<DataWithPagination<SessionsReport[]>> {
    return this.baseAPI.post(Constants.GET_SESSIONS_REPORT_API_URL, filter).pipe(
      map((res) => {
        const data: DataWithPagination<SessionsReport[]> = {
          data: this.mapper.fromListJson(SessionsReport, res.items),
          count: res.count,
        };
        return data;
      })
    );
  }
}
